export const PATTERNS = {
  PHONE_NUMBER: /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
  NUMERIC: /^\d+$/,
  PROMO_CUSTOMER_NUMBER: /^(4[0-9]{7}|1[0-9]{3})$/
}
